import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { normalizeSoccerRedirect, consumeAuthRedirect } from '../utils/paths';
import {
  DAILY_SPORTS_LIFE_WWW,
  isDailySportsLifeHost,
  VERCEL_PRODUCTION_ORIGIN,
} from '../utils/canonicalOrigin';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const redirect = searchParams.get('redirect');
    if (redirect) {
      sessionStorage.setItem('votingRedirectUrl', normalizeSoccerRedirect(decodeURIComponent(redirect)));
    }
  }, [searchParams]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.login(formData);
      login(response.token, response.user);
      // Clear loading state before navigation to prevent overlay
      setLoading(false);
      
      // Return to the page the user was trying to reach (practice vote, live scrimmage, etc.)
      const redirectUrl = consumeAuthRedirect();
      if (redirectUrl) {
        navigate(normalizeSoccerRedirect(redirectUrl), { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" style={{ pointerEvents: loading ? 'none' : 'auto' }}>
      <div className="auth-card">
        <p className="auth-eyebrow">
          <Link to="/">Daily Sports Life</Link>
        </p>
        <h2>Log in</h2>
        
        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>

          <p style={{ margin: '0 0 1rem', textAlign: 'right' }}>
            <Link to="/forgot-password" style={{ fontSize: '0.9rem' }}>
              Forgot password?
            </Link>
          </p>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Don't have an account?{' '}
            <Link to="/register">
              Join here
            </Link>
          </p>
          {isDailySportsLifeHost() && (
            <p className="auth-load-help">
              Site won&apos;t load on your Wi-Fi? Try{' '}
              <a href={`${VERCEL_PRODUCTION_ORIGIN}/login`}>soccer-app-gules.vercel.app</a>
              {' '}or{' '}
              <a href={`${DAILY_SPORTS_LIFE_WWW}/login`}>www.dailysportslife.com</a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;

